// extracted by mini-css-extract-plugin
var _1 = "EmailProfileWidgetCustomFoldersItem-moduleEmailProfileWidgetCustomFoldersItem__fYspH";
export { _1 as "EmailProfileWidgetCustomFoldersItem" }
